import React from "react";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: "border-box",
    width: "100%",
    maxWidth: 640,
    margin: `${theme.spacing(4)}px auto`,
    padding: theme.spacing(2),
  },
  action: {
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "flex-end",
  },
}));

export default function Exitoso({ message, id }) {
  const classes = useStyles();
  const isDuplicate = id === "FOUND";
  const severity = isDuplicate ? "warning" : id === "CANCELLED" ? "info" : "success";

  return (
    <Paper className={classes.root} elevation={1}>
      <Alert severity={severity}>
        {message || "La solicitud se ha procesado."}
      </Alert>
      <div className={classes.action}>
        <Button color="primary" component={RouterLink} to="/">
          Ir al inicio
        </Button>
      </div>
    </Paper>
  );
}
